__webpack_require__.p = "/fast-feast/";